/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import logo from '../../images/logo.png';
import Searchbar from './SearchBar';
import Login from './Login';
import SecondaryNavbar from './SecondaryNavbar'
import { Drawer, Button } from 'antd';
  

function Navbar() {
  const [visible, setVisible] = useState(false)
  
  const showDrawer = () => {
    setVisible(true)
  }
  
  const onClose = () => {
    setVisible(false)
  }

  return (
    <div>
        <div className="grid grid-cols-2 md:grid-cols-8 md:gap-3 bg-white shadow">
            <div className="flex items-center justify-start md:justify-center md:col-span-1 text-purple-700">
              <a onClick={showDrawer}>
                <svg className="fill-current w-8 h-8 ml-5 p-1 md:hidden" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
              </a>
              <a href="/">
                <img className="h-20 w-28 px-4 my-2 border-2 border-dashed border-purple-700 rounded-lg" src={logo} alt="TractorSingh Logo"/>
              </a>
            </div>
            <div className="hidden md:flex md:items-center md:col-span-5">
              {/* col l7 p-5 hide-on-med-and-down */}
              <Searchbar />
            </div>
            <div className="flex items-center justify-end md:col-span-2">
              <Login />
            </div>
        </div>
        <div className="hidden md:block">
          <SecondaryNavbar mode="horizontal" />
        </div>
        <div>
          <Drawer
            placement="left"
            width="auto"
            closable={false}
            onClose={onClose}
            visible={visible}
            bodyStyle={{padding:0}}
          >
            <SecondaryNavbar mode="inline" />
          </Drawer>
        </div>
    </div>
  );
}

export default Navbar;
